export default __webpack_public_path__ + "static/media/endRound6.d09e287b.mp3";